import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
export const TextComponent = ({ text }) => {
    return _jsx(Typography, { children: text });
};
